import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from "react-select";
import { TextField } from '@mui/material';

import api from '@/services/api';

import styles from '@/views/pages/TemplatesManagement/TemplatesFonts.module.scss';

const TemplatesFonts = () => {
	const { dict } = useSelector((state) => state.app);

	const [ edited, setEdited ] = useState(false);

	const [ fontList, setFontList ] = useState([]);
	const [ defaultSettings, setDefaultSettings ] = useState(null);

	const [ fontFamily, setFontFamily ] = useState(undefined);
	const [ header1Size, setHeader1Size ] = useState(0);
	const [ header2Size, setHeader2Size ] = useState(0);
	const [ normalTextSize, setNormalTextSize ] = useState(0);
	const [ interlineSize, setInterlineSize ] = useState(0);

	const startEditing = () => {
		setEdited(true);
	};
	
	const cancelChanges = () => {
		setFontFamily({ value: defaultSettings.fontFamily, label: defaultSettings.fontFamily });
		setHeader1Size(defaultSettings.titleFontSize);
		setHeader2Size(defaultSettings.headerFontSize);
		setNormalTextSize(defaultSettings.textFontSize);
		setInterlineSize(defaultSettings.spacingLine);
		setEdited(false);
	};

	const saveChanges = () => {
		setEdited(false);

		const data = {
			fontFamily: fontFamily.value,
			titleFontSize: +header1Size,
			headerFontSize: +header2Size,
			textFontSize: +normalTextSize,
			spacingLine: +interlineSize,
		};

		api.put('/letter-templates/settings', data).then(() => {
			getSettings();
		});
	};

	const getFontList = () => {
		api.get('/template-settings/font-family').then((response) => {
			setFontList(response.data.map((el) => { return { value: el, label: el }; }));
		});
	};

	const getSettings = () => {
		api.get('/letter-templates/settings').then((response) => {
			setDefaultSettings(response.data);
			setFontFamily({ value: response.data.fontFamily, label: response.data.fontFamily });
			setHeader1Size(response.data.titleFontSize);
			setHeader2Size(response.data.headerFontSize);
			setNormalTextSize(response.data.textFontSize);
			setInterlineSize(response.data.spacingLine);
		});
	};

	useEffect(() => {
		getFontList();
		getSettings();
	}, []);

	return (
		<div className={ styles['templates-fonts__wrapper'] }>
			<div className={ styles['templates-fonts__top'] }>
				<div className={ styles['templates-fonts__top--header'] }>
					{ dict.templatesManagement.fonts.title }
				</div>
				<div className={ styles['templates-fonts__top--edit'] }>
					{!edited && <button 
						className='button__white'
						onClick={ startEditing }
					>
						{ dict.templatesManagement.fonts.edit }
					</button>}
				</div>
			</div>
			<div className={ styles['templates-fonts__container'] }>
				<p 
					className={ styles['templates-fonts__container--text'] }
					style={ { marginTop: 0 } }
				>
					{ dict.templatesManagement.fonts.type }
				</p>
				<div className={ styles['templates-fonts__container__interline'] }>
					<div className={ styles['templates-fonts__container--select'] }>
						<Select
							options={ fontList }
							isSearchable={ false }
							components={ {
								IndicatorSeparator: () => null,
							} }
							value={ fontFamily }
							onChange={ (el) => { setFontFamily(el); } }
							isDisabled={ !edited }
						/>
					</div>
				</div>
				<p 
					className={ styles['templates-fonts__container--text'] } 
				>
					{ dict.templatesManagement.fonts.size }
				</p>
				<div className={ styles['templates-fonts__container__font-sizes'] }>
					<div className={ styles['templates-fonts__container--input'] }>
						<label>{ dict.templatesManagement.fonts.titleSize }</label>
						<TextField
							size='small'
							type='number'
							fullWidth
							value={ header1Size }
							onChange={ (el) => { setHeader1Size(el.target.value); } }
							disabled={ !edited }
						/>
					</div>
					<div className={ styles['templates-fonts__container--input'] }>
						<label>{ dict.templatesManagement.fonts.headerSize }</label>
						<TextField
							size='small'
							type='number'
							fullWidth
							value={ header2Size }
							onChange={ (el) => { setHeader2Size(el.target.value); } }
							disabled={ !edited }
						/>
					</div>
					<div className={ styles['templates-fonts__container--input'] }>
						<label>{ dict.templatesManagement.fonts.regularTextSize }</label>
						<TextField
							size='small'
							type='number'
							fullWidth
							value={ normalTextSize }
							onChange={ (el) => { setNormalTextSize(el.target.value); } }
							disabled={ !edited }
						/>
					</div>
				</div>
				<p className={ styles['templates-fonts__container--text'] }>{ dict.templatesManagement.fonts.interline }</p>
				<div>
					<div className={ styles['templates-fonts__container--input'] }>
						<TextField
							size='small'
							type='number'
							fullWidth
							value={ interlineSize }
							onChange={ (el) => { setInterlineSize(el.target.value); } }
							disabled={ !edited }
						/>
					</div>
				</div>
				{ edited && <div className={ styles['templates-fonts__bottom'] }>
					<button 
						className='button__transparent'
						onClick={ cancelChanges }
					>
						{ dict.templatesManagement.fonts.cancel }
					</button>
					<button 
						className='button__blue'
						onClick={ saveChanges }
					>
						{ dict.templatesManagement.fonts.saveChanges }
					</button>
				</div> }
			</div>
		</div>
	);
};
export default React.memo(TemplatesFonts);